import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { getFacebookFeedUrl } from "../../../functions";

fetch(getFacebookFeedUrl())
  .then(response => response.json())
  .then(data => {
    data = data.data.filter(function(value, index, arr) {
      return value.message != null;
    });
    data = data.filter(function(value, index, arr) {
      return value.attachments?.data[0].media != null;
    });
  });

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      id="facebook-modal"
    >
      <Modal.Body>
        <Container>
          <Row className="show-grid">
            <Col xs={12} lg={6} className="facebook-image-container">
              <code>
                {" "}
                <img className="modal-image" src={props.data.data.imageURL} />
              </code>
            </Col>
            <Col xs={12} lg={6} className="facebook-text-container">
              <code>
                <div className="facebookProfile">
                  <img src={props.data.data.profilePhoto} />
                  <a href="https://www.facebook.com/agriculturevictoria/">
                    Agriculture Victoria
                  </a>
                </div>
              </code>
              <code>
                <span className="facebook-modal-date">
                  {props.data.data.date}
                </span>
                <p className="facebook-description">
                  {props.data.data.descriptionFull}
                </p>
              </code>
              <a href={props.data.data.URL} className="button-primary">
                Visit post on Facebook
              </a>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Button onClick={props.onHide} className="facebook-modal-close">
        X
      </Button>
    </Modal>
  );
}

function FacebookModal(props) {
  const [modalShow, setModalShow] = React.useState(false);

  function keyPress(e) {
    if (e.key == "Enter") {
      setModalShow(true);
    }
  }

  return (
    <div className="container-fluid">
      <div
        className="single-card"
        tabIndex="0"
        onKeyDown={e => keyPress(e)}
        onClick={() => setModalShow(true)}
      >
        <span className="fa fa-facebook-square"></span>
        <h3>{props.data.date}</h3>
        <p>{props.data.description}</p>
        <div className="arrow-container">
          <span>Read full post</span>
          <span className="arrow-right"></span>
        </div>
      </div>

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        data={props}
      />
    </div>
  );
}

export default FacebookModal;
